import { ComponentIds, ConnectorsComponent, ConnectorType, HierarchyUtils, MathUtils, PointConnector, Transform, Vector } from '@inter-ikea-core/core';
import { SystemBase } from '@inter-ikea-core/core-toolbox';
import { AdjustableClothrailLimitsComponent, AdjustableHostComponent, CLOTH_RAIL_RIGHT_FRAME_CONNECTOR_KEY } from '@inter-ikea-storageone/range';
export const ADJUSTABLE_MIN_CONNECTOR = 'adjustable-component-min';
export const ADJUSTABLE_MAX_CONNECTOR = 'adjustable-component-min';
/**
 * Systems that adds min and max distance connectors to the right frame on floor level. They are used
 * to easier align frames to the min and max distance.
 */
export default class FrameMinMaxConnectorsSystem extends SystemBase {
    constructor(coreApi) {
        super(ComponentIds.ALIGNMENT_CONNECTIONS_COMPONENT_ID);
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = ['RemoveClothRailWhenRemovingFrameSystem'];
        this.systemsAfterMe = null;
        this.id = 'FrameMinMaxConnectorsSystem';
        this.addConnectorsToFrame = (frame, clothRailRightPart) => {
            const connectorsComponent = frame.getComponent(ComponentIds.CONNECTORS_COMPONENT_ID);
            const transform = frame.getComponent(ComponentIds.WORLD_TRANSFORM_COMPONENT_ID)?.transform;
            const size = frame.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)?.size;
            const clothRailAssembly = HierarchyUtils.parent(clothRailRightPart);
            const adjustableClothRailLimitsComponent = clothRailAssembly
                ? clothRailAssembly.getComponent(AdjustableClothrailLimitsComponent.id)
                : null;
            if (!connectorsComponent || !size || !transform || !adjustableClothRailLimitsComponent)
                return;
            if (connectorsComponent.connectors.some(c => c.key === ADJUSTABLE_MIN_CONNECTOR || c.key === ADJUSTABLE_MAX_CONNECTOR)) {
                return;
            }
            const newConnectors = [...connectorsComponent.connectors];
            newConnectors.push(this.getConnector(size, transform, adjustableClothRailLimitsComponent, true));
            newConnectors.push(this.getConnector(size, transform, adjustableClothRailLimitsComponent, false));
            frame.addComponent(new ConnectorsComponent(newConnectors ? newConnectors : []));
        };
        this.removeConnectorsFromFrame = (frame) => {
            const connectorsComponent = frame.getComponent(ComponentIds.CONNECTORS_COMPONENT_ID);
            if (!connectorsComponent)
                return;
            const newConnectors = connectorsComponent.connectors.filter(c => c.key !== ADJUSTABLE_MIN_CONNECTOR && c.key !== ADJUSTABLE_MAX_CONNECTOR);
            this.setConnectorsToFrame(frame, newConnectors ? newConnectors : []);
        };
        this.setConnectorsToFrame = (frame, connectors) => {
            frame.addComponent(new ConnectorsComponent(connectors ? connectors : []));
        };
        this.getConnector = (size, transform, adjustableClothRailLimitsComponent, min) => {
            return new PointConnector(min ? ADJUSTABLE_MIN_CONNECTOR : ADJUSTABLE_MAX_CONNECTOR, ConnectorType.ALIGNMENT, new Transform(new Vector(-size.width / 2 -
                (min ? adjustableClothRailLimitsComponent.min : adjustableClothRailLimitsComponent.max), -transform.position.Y, -size.depth / 2), MathUtils.quaternionFromEulerDegrees(new Vector(0, 0, 0))), 11, 1, true, [], ['section-align-opposite-depth-left'], ['section-align-opposite-depth-right']);
        };
        this.coreApi = coreApi;
    }
    onAddComponent(_entity, _newComponent) {
        super.onAddComponent(_entity, _newComponent);
        if (_entity.hasComponent(AdjustableHostComponent.id)) {
            const clothRackAligned = _newComponent.connections.find(c => c.offeringConnector.key === CLOTH_RAIL_RIGHT_FRAME_CONNECTOR_KEY &&
                c.demandingConnector.key.includes('align-point-series-left'));
            if (clothRackAligned) {
                this.addConnectorsToFrame(_entity, clothRackAligned.offeringEntity);
            }
        }
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) {
        super.onUpdateComponent(_entity, _oldComponent, _newComponent);
        if (_entity.hasComponent(AdjustableHostComponent.id)) {
            const clothRackAligned = _newComponent.connections.find(c => c.offeringConnector.key === CLOTH_RAIL_RIGHT_FRAME_CONNECTOR_KEY &&
                c.demandingConnector.key.includes('align-point-series-left'));
            if (clothRackAligned) {
                this.addConnectorsToFrame(_entity, clothRackAligned.offeringEntity);
            }
            else {
                this.removeConnectorsFromFrame(_entity);
            }
        }
    }
}
//# sourceMappingURL=FrameMinMaxConnectorsSystem.js.map